


class NSSThreeUpBuybox extends HTMLElement {
    constructor() {
        super();

        this.debug      = true;

        this.rootURL    = window.Shopify.routes.root;
    }

    handleize(str) {
        return str.toLowerCase().replace("'", "").replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    }

    updateSelectedProduct() {
        const productSelectEl   = this.querySelector(`[name="id"]`),
              optionRadioEls    = this.querySelectorAll(`[nss-buybox-option-radio]:checked`);
        
        this.updateOptionAvailability();

        // Determine variant handle and ID
        if (this.debug) console.log(`[NSS] optionRadioEls:`, optionRadioEls);

        let variantHandlesArray = [];
        optionRadioEls.forEach((optionRadioEl) => {
            variantHandlesArray.push(optionRadioEl.getAttribute(`nss-buybox-option-value`));
        });
        let variantHandle = variantHandlesArray.join().replace(`,`, '-');
        if (this.debug) console.log(`[NSS] variantHandle:`, variantHandle);

        const selectOptionEl = productSelectEl.querySelector(`[nss-option-handle="${variantHandle}"]`);
        let variantId = selectOptionEl.value;
        if (this.debug) console.log(`[NSS] variantId:`, variantId);

        // Selected product
        productSelectEl.value = variantId;

        // Variant URL deep-linking
        let url = new URL(location.href);
        url.searchParams.set('variant', variantId);
        window.history.pushState({}, null, url);

        // Update availability
        const productData   = JSON.parse(this.querySelector(`#ProductJson`).textContent),
              variantData   = productData.variants.find(v => v.id === parseInt(variantId)),
              atcGrpEl      = this.querySelector(`[nss-atc-controls]`);

        if (this.debug) console.log(`[NSS] variantData.available:`, variantData.available);

        if (variantData.available) {
            atcGrpEl.removeAttribute(`nss-atc-controls-sold-out`);
        } else {
            atcGrpEl.setAttribute(`nss-atc-controls-sold-out`, ``);
        }
    }

    updateOptionAvailability() {
        const productData   = JSON.parse(this.querySelector(`#ProductJson`).textContent),
              option1GrpEl  = this.querySelector(`[nss-buybox-option="1"]`),
              option2GrpEl  = this.querySelector(`[nss-buybox-option="2"]`);

        if (this.debug) console.log(`[NSS] productData:`, productData);

        if (option1GrpEl) {
            const option1RadioEl    = option1GrpEl.querySelector(`[nss-buybox-option-radio]:checked`),
                  option1Handle     = option1RadioEl.getAttribute(`nss-buybox-option-value`);
            
            const option2GrpValueEls    = option2GrpEl.querySelectorAll(`.nss-buybox__value`);
            option2GrpValueEls.forEach((valueEl) => {
                valueEl.classList.add(`nss-buybox__value-unavailable`);
            });

            productData.variants.forEach((variant) => {
                if (variant.available && this.handleize(variant.option1) === option1Handle) {
                    const option2RadioEl = option2GrpEl.querySelector(`[nss-buybox-option-value="${this.handleize(variant.option2)}"]`);
                    option2RadioEl.parentElement.classList.remove(`nss-buybox__value-unavailable`);
                }
            });
        }

    }

    matchDescHeights() {
        const productCardEls    = this.querySelectorAll(`.nss-threeup-buybox__card`),
              descHeights       = [];
        
        productCardEls.forEach((productCardEl) => {
            const descEl = productCardEl.querySelector(`.nss-product-card__description`);

            descHeights.push(descEl.getBoundingClientRect().height);
        });

        if (this.debug) console.log(`[NSS] descHeights:`, descHeights);
        
        productCardEls.forEach((productCardEl) => {
            const descEl = productCardEl.querySelector(`.nss-product-card__description`);
            if (this.debug) console.log(`[NSS] Math.max(...descHeights):`, Math.max(...descHeights));

            if (window.innerWidth >= 990) {
                descEl.style.height = `${Math.max(...descHeights)}px`;
            } else {
                descEl.style.height = ``;
            }
        });
    }

    connectedCallback() {
        if (this.debug) console.log(`[NSS] 3-Up Buybox connected.`);

        const productCardEls    = this.querySelectorAll(`.nss-threeup-buybox__card`);
        
        productCardEls.forEach((productCardEl) => {
            const productSelectEl   = productCardEl.querySelector(`[name="id"]`),
                  atcBtnEl          = productCardEl.querySelector(`.nss-product-card__atc-btn`);

            productSelectEl.addEventListener(`change`, (e) => {
                if (this.debug) console.log(`[NSS] productSelectEl.value:`, productSelectEl.value);

                if (productSelectEl.value !== `Choose an option`) {
                    atcBtnEl.removeAttribute(`disabled`);
                } else {
                    atcBtnEl.setAttribute(`disabled`, true);
                }
            });
        });

        this.matchDescHeights();

        window.addEventListener(`resize`, () => {
            setTimeout(() => this.matchDescHeights(), 100);
        });
    }
}

customElements.define(`nss-threeup-buybox`, NSSThreeUpBuybox);